import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const topSwipeApi = {
  list (params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/topswipes/`,
      {params: params})
  },
  detail (topSwipeId, params) {
    return axios.get(
      `${ApiSetting.baseUrl}/api/topswipes/${topSwipeId}/`,
      {params: params})
  },
  create (params) {
    // 创建新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/topswipes/`, querystring.stringify(params))
    return axios.post(
      `${ApiSetting.baseUrl}/api/topswipes/`, querystring.stringify(params))
  },
  update (topSwipeId, params) {
    // 更新主题
    // return axios.post(
    //   `${ApiSetting.baseUrl}/api/topswipes/`, querystring.stringify(params))
    return axios.put(
      `${ApiSetting.baseUrl}/api/topswipes/${topSwipeId}/`, querystring.stringify(params))
  },
  delete (topSwipeId) {
    window.console.log("发起删除请求")
    return axios.delete(
      `${ApiSetting.baseUrl}/api/topswipes/${topSwipeId}/`
    )
  }
}

export default topSwipeApi
